module.exports = __webpack_public_path__ + "static/media/surf.e7a3d50b.jpg";